module.exports = __webpack_public_path__ + "static/media/galdinsWon_25000_50000.c97558bf.png";